import { usePagination } from "react-instantsearch";
import { m } from "#/paraglide/messages";

function PaginationIcon({ direction }: { direction: "previous" | "next" }) {
	const icon =
		direction === "previous"
			? "sprite-ic_fluent_chevron_left_24_regular"
			: "sprite-ic_fluent_chevron_right_24_regular";

	return (
		<svg aria-hidden="true" className="icon icon-18 icon-lg-24">
			<use xlinkHref={`/umbrella/ui/icon-sprite.svg#${icon}`} />
		</svg>
	);
}

export default function AlgoliaPagination() {
	const { currentRefinement, isFirstPage, isLastPage, nbPages, pages, refine } =
		usePagination();

	if (pages.length <= 1) {
		return null;
	}

	return (
		<nav
			aria-label={m.search_pagination_counter({
				current: currentRefinement + 1,
				total: nbPages,
			})}
			className="pagination"
		>
			<button
				aria-label={m.pagination_previous()}
				className={`pagination-link ${isFirstPage ? "disabled" : ""}`}
				disabled={isFirstPage}
				onClick={() => refine(currentRefinement - 1)}
				type="button"
			>
				<PaginationIcon direction="previous" />
				<span className="sr-only">{m.pagination_previous()}</span>
			</button>
			{pages.map((page) => (
				<button
					aria-current={page === currentRefinement ? "page" : undefined}
					className={`pagination-link ${page === currentRefinement ? "active" : ""}`}
					key={page}
					onClick={() => refine(page)}
					type="button"
				>
					{page + 1}
				</button>
			))}
			<button
				aria-label={m.pagination_next()}
				className={`pagination-link ${isLastPage ? "disabled" : ""}`}
				disabled={isLastPage}
				onClick={() => refine(currentRefinement + 1)}
				type="button"
			>
				<PaginationIcon direction="next" />
				<span className="sr-only">{m.pagination_next()}</span>
			</button>
		</nav>
	);
}
